"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _date = require("../../utils/date");
var _excluded = ["format"];
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var Timer = /*#__PURE__*/function (_React$PureComponent) {
  function Timer(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, Timer);
    _this = _callSuper(this, Timer, [props]);
    _this.state = {
      seconds: props.initialSeconds,
      initialSeconds: props.initialSeconds
    };
    return _this;
  }
  (0, _inherits2["default"])(Timer, _React$PureComponent);
  return (0, _createClass2["default"])(Timer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      this.interval = setInterval(function () {
        return _this2.tick();
      }, 1000);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearInterval(this.interval);
    }
  }, {
    key: "tick",
    value: function tick() {
      this.setState(function (prevState) {
        return {
          seconds: prevState.seconds + 1
        };
      });
    }
  }, {
    key: "render",
    value: function render() {
      var seconds = this.state.seconds;
      var _this$props = this.props,
        format = _this$props.format,
        props = (0, _objectWithoutProperties2["default"])(_this$props, _excluded);
      return /*#__PURE__*/_react["default"].createElement(StyledTimer, (0, _extends2["default"])({
        key: seconds
      }, props), Timer.formattedValue(seconds, format));
    }
  }], [{
    key: "formattedValue",
    value: function formattedValue(seconds, format) {
      var duration = (0, _date.getDurationTime)({
        seconds: seconds
      });
      return (0, _date.formatDate)(duration, format);
    }
  }, {
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.initialSeconds !== prevState.initialSeconds) {
        return {
          seconds: nextProps.initialSeconds
        };
      }
      return null;
    }
  }]);
}(_react["default"].PureComponent);
Timer.propTypes = {
  initialSeconds: _propTypes["default"].number,
  className: _propTypes["default"].string,
  format: _propTypes["default"].string
};
Timer.defaultProps = {
  initialSeconds: 0,
  className: '',
  format: 'mm:ss'
};
var StyledTimer = _styledComponents["default"].div.withConfig({
  displayName: "Timer__StyledTimer",
  componentId: "sc-ujtjdj-0"
})(["font-size:17px;font-weight:500;"]);
var _default = exports["default"] = Timer;